import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const publicApi = {
  register: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/public/shop/register",
      data,
      method: "post",
    }),
};
